import type { StringRegistryItem, StringRegistryLocaleValue } from '../types/stringRegistryTypes';

/** Locale rows from GLOBAL template items on a string entry */
export function getGlobalLocaleOverrides(entry?: StringRegistryItem): StringRegistryLocaleValue[] {
  if (!entry?.templateItems?.length) return [];
  return entry.templateItems.flatMap((row) => row.localeOverrides || []);
}

export function hasGlobalLocaleData(entry?: StringRegistryItem): boolean {
  return getGlobalLocaleOverrides(entry).length > 0;
}
